module.exports = {
	"34099": [
		"Tennessee Valley Authority",
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"41305": [
		"The Johns Hopkins University",
		[
			12,
			"n"
		]
	],
	"42523": [
		"Litton Industries, Inc.",
		[
			4,
			"c"
		],
		[
			16
		]
	],
	"128005": [
		"Charles Stark Draper Laboratory, Inc.",
		[
			22,
			"n"
		]
	],
	"0C0000BEWQ": [
		"Bharat Dynamics Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			3
		],
		[
			4,
			"n"
		],
		[
			8,
			"n"
		],
		[
			11
		],
		[
			12,
			"nc"
		],
		[
			14,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"nc"
		],
		[
			19,
			"c"
		],
		[
			21,
			"c"
		],
		[
			22,
			"n"
		]
	],
	"0C00003BJO": [
		"Hanwha Corp",
		[
			6
		],
		[
			9
		],
		[
			17
		],
		[
			18,
			"n"
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		]
	],
	"0C0000B067": [
		"LIG Nex1 Co Ltd",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			3
		],
		[
			4,
			"c"
		],
		[
			6
		],
		[
			8,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			14,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"c"
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		]
	],
	"0C00000P8P": [
		"Norinco International Co Ltd",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			3
		],
		[
			4,
			"c"
		],
		[
			6
		],
		[
			8,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			14,
			"c"
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"c"
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		]
	],
	"0C00004DKW": [
		"Poongsan Corp",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			3
		],
		[
			4,
			"c"
		],
		[
			5,
			"c"
		],
		[
			7,
			"c"
		],
		[
			8,
			"c"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			13,
			"c"
		],
		[
			14,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			19,
			"c"
		],
		[
			21,
			"c"
		]
	],
	"0C00000B4B": [
		"Elbit Systems Ltd",
		[
			2
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			10,
			"c"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"c"
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		]
	],
	"0C00000BVX": [
		"Northrop Grumman Corp",
		[
			0,
			"c"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			4,
			"c"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"nc"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		],
		[
			22,
			"n"
		]
	],
	"0C00000CME": [
		"Textron Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"c"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"nc"
		],
		[
			13,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"c"
		],
		[
			20
		],
		[
			21,
			"c"
		],
		[
			22,
			"n"
		]
	],
	"0C0000BHXS": [
		"Anhui Great Wall Military Industry Co Ltd",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			4,
			"c"
		],
		[
			8,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			14,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"c"
		],
		[
			19,
			"c"
		]
	],
	"0C00000ZPZ": [
		"Aryt Industries Ltd",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			4,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			14,
			"c"
		],
		[
			17
		],
		[
			18,
			"c"
		],
		[
			19,
			"c"
		]
	],
	"0C00003BK1": [
		"SNT Dynamics Co Ltd",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			3
		],
		[
			4,
			"c"
		],
		[
			8,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"c"
		]
	],
	"0C0000BOAZ": [
		"China Next-Gen Commerce and Supply Chain Ltd",
		[
			1,
			"c"
		],
		[
			18,
			"c"
		]
	],
	"0C00000UK2": [
		"Airbus SE",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000MOI": [
		"Babcock International Group PLC",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000D21": [
		"BAE Systems PLC",
		[
			0,
			"c"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			4,
			"c"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C000006YX": [
		"Boeing Co",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00004322": [
		"Booz Allen Hamilton Holding Corp",
		[
			2,
			"n"
		],
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C0000CSPZ": [
		"Brookfield Asset Management Ltd",
		[
			11
		],
		[
			18,
			"n"
		]
	],
	"0C00006AWF": [
		"BWX Technologies Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		]
	],
	"0C0000072U": [
		"CACI International Inc",
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		]
	],
	"0C00004DCI": [
		"China Shipbuilding Industry Corp",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		]
	],
	"0C00000NB9": [
		"Cohort PLC",
		[
			1,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		]
	],
	"0C0000B4EB": [
		"Fortive Corp",
		[
			2,
			"n"
		],
		[
			11
		],
		[
			18,
			"n"
		]
	],
	"0C000007TZ": [
		"General Dynamics Corp",
		[
			0,
			"c"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			4,
			"c"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"nc"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			19,
			"c"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000B7K": [
		"L3Harris Technologies Inc",
		[
			0,
			"c"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			4,
			"c"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"nc"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000Y8K": [
		"Kanadevia Corp",
		[
			11
		],
		[
			18,
			"n"
		]
	],
	"0C00000BBJ": [
		"Honeywell International Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00006J8C": [
		"Huntington Ingalls Industries Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000BN5": [
		"Jacobs Solutions Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000L4T": [
		"KBR Inc",
		[
			6
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		]
	],
	"0C000016LW": [
		"Larsen & Toubro Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			3
		],
		[
			4,
			"n"
		],
		[
			8,
			"n"
		],
		[
			9
		],
		[
			10,
			"nc"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			22,
			"n"
		]
	],
	"0C00000L0C": [
		"Leidos Holdings Inc",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000QFH": [
		"Leonardo SpA",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			3
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C000008H6": [
		"Moog Inc",
		[
			1,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00003BHT": [
		"Poongsan Holdings Corp",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			4,
			"c"
		],
		[
			7,
			"c"
		],
		[
			8,
			"c"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			17
		],
		[
			18,
			"n"
		],
		[
			19,
			"c"
		]
	],
	"0C00004D3A": [
		"Premier Explosives Ltd",
		[
			1,
			"c"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			17
		],
		[
			18,
			"n"
		]
	],
	"0C00000CUU": [
		"RTX Corp",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000DSZ": [
		"Rolls-Royce Holdings PLC",
		[
			5,
			"n"
		],
		[
			6
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000VL5": [
		"Safran SA",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"c"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C000027WA": [
		"Science Applications International Corp",
		[
			1,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		]
	],
	"0C00000MVT": [
		"Serco Group PLC",
		[
			5,
			"c"
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			18,
			"n"
		],
		[
			20
		]
	],
	"0C00000UGF": [
		"SGL Carbon SE",
		[
			1,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			18,
			"n"
		]
	],
	"0C000055LX": [
		"Steel Partners Holdings LP",
		[
			1,
			"n"
		],
		[
			11
		],
		[
			18,
			"n"
		]
	],
	"0C00001764": [
		"Tata Power Co Ltd",
		[
			0,
			"n"
		],
		[
			4,
			"n"
		],
		[
			12,
			"n"
		],
		[
			18,
			"n"
		]
	],
	"0C00000VIJ": [
		"Thales",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"c"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C000017AU": [
		"Walchandnagar Industries Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			3
		],
		[
			4,
			"n"
		],
		[
			8,
			"n"
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"n"
		],
		[
			22,
			"n"
		]
	],
	"0C000007PO": [
		"Fluor Corp",
		[
			1,
			"n"
		],
		[
			2,
			"n"
		],
		[
			5,
			"n"
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"nc"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C0000084Y": [
		"Lockheed Martin Corp",
		[
			1,
			"n"
		],
		[
			2,
			"nc"
		],
		[
			5,
			"nc"
		],
		[
			6
		],
		[
			7,
			"n"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"nc"
		],
		[
			13,
			"n"
		],
		[
			14,
			"n"
		],
		[
			15
		],
		[
			16
		],
		[
			18,
			"nc"
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00003AXJ": [
		"Ashot- Ashkelon Industries Ltd",
		[
			11
		],
		[
			15
		],
		[
			19,
			"c"
		]
	],
	"0C0000BN7B": [
		"China Satellite Communications Co Ltd",
		[
			15
		],
		[
			19,
			"c"
		]
	],
	"0C00000PB6": [
		"China Spacesat Co Ltd",
		[
			0,
			"nc"
		],
		[
			1,
			"nc"
		],
		[
			4,
			"c"
		],
		[
			8,
			"c"
		],
		[
			15
		],
		[
			19,
			"c"
		]
	],
	"0C00003BLI": [
		"Hanwha Aerospace Co Ltd",
		[
			11
		],
		[
			15
		],
		[
			19,
			"c"
		]
	],
	"0C00000BPY": [
		"National Presto Industries Inc",
		[
			8,
			"c"
		],
		[
			9
		],
		[
			11
		],
		[
			14,
			"c"
		],
		[
			15
		],
		[
			17
		],
		[
			19,
			"c"
		]
	],
	"0C0000C2QH": [
		"Leonardo DRS Inc",
		[
			9
		],
		[
			11
		],
		[
			15
		]
	],
	"0C0000A652": [
		"Avioane Craiova SA"
	],
	"0C00000VVO": [
		"Dassault Aviation SA",
		[
			1,
			"n"
		],
		[
			5,
			"n"
		],
		[
			6
		],
		[
			9
		],
		[
			10,
			"n"
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00008IEM": [
		"SNT Holdings",
		[
			0,
			"c"
		],
		[
			4,
			"c"
		],
		[
			8,
			"c"
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			16
		],
		[
			17
		]
	],
	"0C000009PK": [
		"Kratos Defense & Security Solutions Inc",
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			22,
			"n"
		]
	],
	"0C00003X0A": [
		"Parsons Corp",
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			20
		],
		[
			22,
			"n"
		]
	],
	"0C00000OGP": [
		"AECC Aero-Engine Controls Co Ltd",
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000UGK": [
		"Rheinmetall AG",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			15
		],
		[
			16
		],
		[
			20
		]
	],
	"0C000007U0": [
		"GE Aerospace",
		[
			5,
			"n"
		],
		[
			6
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000XHY": [
		"Saab AB",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000Y7X": [
		"Mitsubishi Heavy Industries Ltd",
		[
			5
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000BF17": [
		"Hindustan Aeronautics Ltd",
		[
			6
		],
		[
			8,
			"n"
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000AQCN": [
		"V2X Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000AOXB": [
		"Fincantieri SpA",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000C49": [
		"Parker Hannifin Corp",
		[
			6
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000IOQ": [
		"TransDigm Group Inc",
		[
			6
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			15
		],
		[
			20
		]
	],
	"0C000015UA": [
		"Aselsan Elektronik Sanayi Ve Ticaret AS",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			16
		],
		[
			20
		]
	],
	"0C00008UYR": [
		"Korea Aerospace Industries Ltd",
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000XZO": [
		"Singapore Technologies Engineering Ltd",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000CKK": [
		"Teledyne Technologies Inc",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000C1U": [
		"Oshkosh Corp",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000FNX": [
		"Kawasaki Heavy Industries Ltd",
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000O1X": [
		"thyssenkrupp AG",
		[
			20
		]
	],
	"0C000015XR": [
		"Bharat Electronics Ltd",
		[
			6
		],
		[
			11
		],
		[
			12
		],
		[
			13
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000NSI": [
		"Fujitsu Ltd",
		[
			11
		],
		[
			20
		]
	],
	"0C00000N5J": [
		"QinetiQ Group PLC",
		[
			5
		],
		[
			6
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000BYOG": [
		"Hensoldt AG",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000UPG": [
		"CNNC International Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			20
		]
	],
	"0C00000B30": [
		"Eaton Corp PLC",
		[
			2,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000AU7": [
		"Curtiss-Wright Corp",
		[
			1,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C000016KX": [
		"Kongsberg Gruppen ASA",
		[
			5,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000ABC": [
		"Amphenol Corp",
		[
			6
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000731": [
		"CAE Inc",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000AR7P": [
		"Keysight Technologies Inc",
		[
			6
		],
		[
			20
		]
	],
	"0C000009IG": [
		"Viasat Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000AHTD": [
		"Hyundai Rotem Co",
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000N40": [
		"Melrose Industries PLC",
		[
			5,
			"n"
		],
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000BR3": [
		"NEC Corp",
		[
			20
		]
	],
	"0C0000BYPZ": [
		"Mazagon Dock Shipbuilders Ltd",
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000FXW": [
		"Mitsubishi Electric Corp",
		[
			20
		]
	],
	"0C00000B97": [
		"Heico Corp",
		[
			6
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		],
		[
			20
		]
	],
	"0C0000B72P": [
		"Howmet Aerospace Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000CRN": [
		"TTM Technologies Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		],
		[
			20
		]
	],
	"0C00000NWR": [
		"Hyundai Motor Co",
		[
			6
		]
	],
	"0C00000L9W": [
		"Austal Ltd",
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		]
	],
	"0C000008C7": [
		"Mercury Systems Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		]
	],
	"0C0000F8AC": [
		"StandardAero Inc",
		[
			6
		]
	],
	"0C00000WSG": [
		"Indra Sistemas SA",
		[
			6
		],
		[
			11
		],
		[
			15
		]
	],
	"0C00000L56": [
		"Spirit AeroSystems Holdings Inc",
		[
			6
		],
		[
			11
		],
		[
			12,
			"n"
		],
		[
			15
		]
	],
	"0C0000D3I4": [
		"RENK Group AG",
		[
			6
		],
		[
			11
		]
	],
	"0C0000096C": [
		"AAR Corp",
		[
			6
		],
		[
			15
		]
	],
	"0C0000079N": [
		"Lumen Technologies Inc",
		[
			6
		]
	],
	"0C00000UH1": [
		"MTU Aero Engines AG",
		[
			5
		],
		[
			6
		],
		[
			11
		],
		[
			15
		]
	],
	"0C000009Q1": [
		"Woodward Inc",
		[
			6
		],
		[
			11
		],
		[
			15
		]
	],
	"0C00000VKI": [
		"SES SA",
		[
			6
		],
		[
			11
		]
	],
	"0C00000BA4": [
		"Hexcel Corp",
		[
			6
		],
		[
			15
		]
	],
	"0C00000WMK": [
		"Wartsila Corp",
		[
			2,
			"n"
		],
		[
			11
		]
	],
	"0C00000UOA": [
		"AviChina Industry & Technology Co Ltd",
		[
			2
		],
		[
			13
		],
		[
			15
		]
	],
	"0C00008HY1": [
		"Ace Technologies Corp",
		[
			15
		]
	],
	"0C000015QJ": [
		"Adani Enterprises Ltd",
		[
			15
		]
	],
	"0C00000PBT": [
		"Addsino Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000036MF": [
		"Aerostar SA",
		[
			11
		],
		[
			15
		]
	],
	"0C00000PB1": [
		"AeroVironment Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C00000971": [
		"Air Transport Services Group Inc",
		[
			15
		]
	],
	"0C00000IHJ": [
		"AirBoss of America Corp",
		[
			15
		]
	],
	"0C000009BL": [
		"Albany International Corp",
		[
			15
		]
	],
	"0C000009D4": [
		"Allient Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C00008O41": [
		"Allison Transmission Holdings Inc",
		[
			15
		]
	],
	"0C00000AB0": [
		"AMETEK Inc",
		[
			15
		]
	],
	"0C0000BE29": [
		"Apollo Micro Systems Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000015UO": [
		"Astra Microwave Products Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00000AGR": [
		"Astronics Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C000009CD": [
		"ATI Inc",
		[
			15
		]
	],
	"0C00000ON0": [
		"Avic Shenyang Aircraft Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C0000AZ1P": [
		"Avio SpA",
		[
			15
		]
	],
	"0C00000N3Z": [
		"Avon Technologies PLC",
		[
			11
		],
		[
			15
		]
	],
	"0C00000MP2": [
		"BATM Advanced Communications Ltd",
		[
			15
		]
	],
	"0C0000CVAY": [
		"Beijing Shenzhou Aerospace Software Technology Co Ltd",
		[
			15
		]
	],
	"0C000006VU": [
		"Bel Fuse Inc",
		[
			15
		]
	],
	"0C000015VT": [
		"BEML Ltd",
		[
			8,
			"n"
		],
		[
			11
		],
		[
			15
		]
	],
	"0C000006W2": [
		"Benchmark Electronics Inc",
		[
			15
		]
	],
	"0C00000MQJ": [
		"Bodycote PLC",
		[
			15
		]
	],
	"0C00000ICA": [
		"Bombardier Inc",
		[
			15
		]
	],
	"0C00000ILB": [
		"Calian Group Ltd",
		[
			15
		]
	],
	"0C0000B3C7": [
		"Changsha Jingjia Microelectronics Co Ltd",
		[
			15
		]
	],
	"0C00000Q64": [
		"Chemring Group PLC",
		[
			5
		],
		[
			11
		],
		[
			15
		]
	],
	"0C00000OJ0": [
		"China Aerospace Times Electronic Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C0000BHC7": [
		"China Isotope & Radiation Corp",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			15
		]
	],
	"0C0000AXHA": [
		"China National Nuclear Power Co Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			15
		]
	],
	"0C0000BBFU": [
		"Cochin Shipyard Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00000LGY": [
		"Codan Ltd",
		[
			15
		]
	],
	"0C0000BVDB": [
		"Colt CZ Group SE",
		[
			11
		],
		[
			15
		]
	],
	"0C00000AN9": [
		"Commercial Vehicle Group Inc",
		[
			15
		]
	],
	"0C00000AP0": [
		"Comtech Telecommunications Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C00000AS8": [
		"Crane Co",
		[
			15
		]
	],
	"0C00004AI6": [
		"CSBC Corp Taiwan",
		[
			11
		],
		[
			15
		]
	],
	"0C00000OQZ": [
		"CSSC Offshore & Marine Engineering (Group) Co Ltd",
		[
			15
		]
	],
	"0C00000Y8V": [
		"Daikin Industries Ltd",
		[
			4,
			"c"
		],
		[
			11
		],
		[
			15
		],
		[
			16
		]
	],
	"0C0000CBOU": [
		"Data Patterns (India) Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00000B1B": [
		"Ducommun Inc",
		[
			1,
			"n"
		],
		[
			11
		],
		[
			15
		],
		[
			16
		]
	],
	"0C0000164T": [
		"Dynamatic Technologies Ltd",
		[
			15
		]
	],
	"0C00000LKK": [
		"Electro Optic Systems Hldgs Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000007F6": [
		"Embraer SA",
		[
			15
		]
	],
	"0C000007II": [
		"ESCO Technologies Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C0000AORW": [
		"FACC AG",
		[
			15
		]
	],
	"0C000007QK": [
		"Formula Systems (1985) Ltd",
		[
			15
		]
	],
	"0C0000AUED": [
		"Fujian Torch Electron Technology Co Ltd",
		[
			15
		]
	],
	"0C0000BIW3": [
		"Garden Reach Shipbuilders & Engineers Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000007VP": [
		"Gilat Satellite Networks Ltd",
		[
			15
		]
	],
	"0C00000NUN": [
		"Goodwin PLC",
		[
			15
		]
	],
	"0C000007Y2": [
		"Graham Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C0000BQD1": [
		"Hanwha Systems Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000016CF": [
		"HBL Engineering Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C0000C8GI": [
		"HD Hyundai Heavy Industries",
		[
			15
		]
	],
	"0C00000FEA": [
		"Heroux-Devtek Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C000016E6": [
		"Honeywell Automation India Ltd",
		[
			1,
			"n"
		],
		[
			15
		]
	],
	"0C00002XKA": [
		"ICL Group Ltd",
		[
			0,
			"c"
		],
		[
			11
		],
		[
			15
		],
		[
			16
		]
	],
	"0C00000Y9A": [
		"IHI Corp",
		[
			15
		]
	],
	"0C00000OI9": [
		"Inner Mongolia First Machinery Group Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000016H9": [
		"Intracom Holdings SA",
		[
			11
		],
		[
			15
		]
	],
	"0C00003EOJ": [
		"Invisio AB",
		[
			15
		]
	],
	"0C00001843": [
		"Iridium Communications Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C000016FD": [
		"ITI Ltd",
		[
			15
		]
	],
	"0C00000BMC": [
		"ITT Inc",
		[
			15
		]
	],
	"0C00000NSG": [
		"Fisher (James) & Sons PLC",
		[
			15
		]
	],
	"0C00000P1I": [
		"Jiangxi Hongdu Aviation Industry Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000017D9": [
		"Jianshe Industry Group (Yunnan) Co Ltd",
		[
			15
		]
	],
	"0C000016JS": [
		"Karel Elektronik Sanayi ve Ticaret AS",
		[
			15
		]
	],
	"0C000016KL": [
		"Kitron ASA",
		[
			11
		],
		[
			15
		]
	],
	"0C0000AKP6": [
		"Knowles Corp",
		[
			15
		]
	],
	"0C000007ZT": [
		"Kopin Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C0000CSKW": [
		"KSEC Intelligent Technology Co Ltd",
		[
			15
		]
	],
	"0C000090DV": [
		"L&T Finance Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			4,
			"n"
		],
		[
			15
		],
		[
			16
		]
	],
	"0C0000B5P5": [
		"L&T Technology Services Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			4,
			"n"
		],
		[
			15
		],
		[
			16
		]
	],
	"0C0000B4T6": [
		"LTIMindtree Ltd",
		[
			0,
			"n"
		],
		[
			1,
			"n"
		],
		[
			4,
			"n"
		],
		[
			8,
			"n"
		],
		[
			15
		],
		[
			16
		]
	],
	"0C00008Z26": [
		"MACOM Technology Solutions Holdings Inc",
		[
			15
		]
	],
	"0C0000C39G": [
		"MDA Space Ltd",
		[
			15
		]
	],
	"0C0000C583": [
		"Mildef Group AB",
		[
			11
		],
		[
			15
		]
	],
	"0C0000BF89": [
		"Mishra Dhatu Nigam Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00000Q3R": [
		"Morgan Advanced Materials PLC",
		[
			15
		]
	],
	"0C00000MYU": [
		"MS International PLC",
		[
			11
		],
		[
			15
		]
	],
	"0C0000BF32": [
		"nLight Inc",
		[
			15
		]
	],
	"0C00000P9L": [
		"North Industries Group Red Arrow Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C0000CC9D": [
		"NuScale Power Corp",
		[
			1,
			"n"
		],
		[
			15
		]
	],
	"0C00000BYE": [
		"Oceaneering International Inc",
		[
			15
		]
	],
	"0C000016TU": [
		"Otokar Otomotiv Ve Savunma Sanayi AS",
		[
			11
		],
		[
			15
		]
	],
	"0C00000C3V": [
		"PAR Technology Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C00000C45": [
		"Park Aerospace Corp",
		[
			11
		],
		[
			15
		]
	],
	"0C00000C9V": [
		"Plexus Corp",
		[
			15
		]
	],
	"0C00000YL2": [
		"Pressure Technologies PLC",
		[
			15
		]
	],
	"0C000008Q6": [
		"RBC Bearings Inc",
		[
			15
		]
	],
	"0C00004BS0": [
		"Swan Defence and Heavy Industries Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C000016Z6": [
		"Reunert Ltd",
		[
			15
		]
	],
	"0C00000MYW": [
		"Ricardo PLC",
		[
			11
		],
		[
			15
		]
	],
	"0C00000MXI": [
		"Rolta India Ltd",
		[
			15
		]
	],
	"0C00009TYL": [
		"Rostov Helicopter Production Complex Rostvertol PJSC",
		[
			15
		]
	],
	"0C000008WK": [
		"Sanmina Corp",
		[
			15
		]
	],
	"0C00000MVV": [
		"Senior PLC",
		[
			5
		],
		[
			15
		]
	],
	"0C00000UFY": [
		"SFC Energy AG",
		[
			15
		]
	],
	"0C0000CD29": [
		"Shaanxi Huaqin Technology Industry Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00002BYC": [
		"ShinMaywa Industries Ltd",
		[
			15
		]
	],
	"0C00000WCB": [
		"Sichuan Chengfei Integration Technology Corp Ltd",
		[
			15
		]
	],
	"0C0000C3FV": [
		"SkyWater Technology Inc",
		[
			15
		]
	],
	"0C00000GNG": [
		"Smiths Group PLC",
		[
			11
		],
		[
			15
		]
	],
	"0C00003IYO": [
		"SNT Motiv",
		[
			15
		]
	],
	"0C0000172S": [
		"Solar Industries India Ltd",
		[
			1,
			"c"
		],
		[
			8,
			"c"
		],
		[
			9
		],
		[
			11
		],
		[
			12,
			"c"
		],
		[
			15
		]
	],
	"0C0000175V": [
		"Taneja Aerospace & Aviation Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00001760": [
		"Tata Consultancy Services Ltd",
		[
			4,
			"n"
		],
		[
			15
		],
		[
			16
		]
	],
	"0C00001762": [
		"Tata Investment Corp Ltd",
		[
			0,
			"n"
		],
		[
			4,
			"n"
		],
		[
			15
		],
		[
			16
		]
	],
	"0C000017JO": [
		"Taurus Armas SA",
		[
			11
		],
		[
			15
		]
	],
	"0C00000OVI": [
		"Tellhow Sci-Tech Co Ltd",
		[
			15
		]
	],
	"0C0000BEII": [
		"Tianjin 712 Communication & Broadcasting Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C00001776": [
		"Timken India Ltd",
		[
			15
		]
	],
	"0C00000CR5": [
		"Triumph Group Inc",
		[
			11
		],
		[
			15
		]
	],
	"0C00000NQ7": [
		"TT Electronics PLC",
		[
			15
		]
	],
	"0C0000CAEZ": [
		"Ventia Services Group Ltd",
		[
			15
		]
	],
	"0C000009IK": [
		"Vicor Corp",
		[
			15
		]
	],
	"0C00004DM6": [
		"Vitrocell Co Ltd",
		[
			15
		]
	],
	"0C000009KE": [
		"VSE Corp",
		[
			15
		]
	],
	"0C00008IHW": [
		"Woori Technology Incorporation",
		[
			15
		]
	],
	"0C00006GQ4": [
		"Wuhan Guide Infrared Co Ltd",
		[
			11
		],
		[
			15
		]
	],
	"0C0000AQ79": [
		"Xi'an Tian He Defense Technology Co Ltd",
		[
			15
		]
	],
	"0C0000BMFC": [
		"Xi'an Triangle Defense Co Ltd",
		[
			15
		]
	],
	"0C0000968F": [
		"Yakovlev PJSC",
		[
			15
		]
	],
	"0C00000Y40": [
		"Zhejiang Dali Technology Co Ltd",
		[
			15
		]
	],
	"0C00000ASP": [
		"CRH PLC",
		[
			5,
			"c"
		]
	],
	"0C0000EWUB": [
		"Amentum Holdings Inc",
		[
			9
		],
		[
			14,
			"n"
		]
	],
	"0C00000PO1": [
		"Brookfield Renewable Partners LP",
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C00000744": [
		"Cameco Corp",
		[
			9
		],
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C00003BIQ": [
		"Doosan Enerbility Co Ltd",
		[
			9
		]
	],
	"0C000095SO": [
		"United Aircraft Corp JSC",
		[
			0,
			"c"
		],
		[
			1,
			"c"
		],
		[
			3
		]
	],
	"0C0000BF2T": [
		"Sandhar Technologies Ltd",
		[
			1,
			"c"
		],
		[
			11
		]
	],
	"0C00000VDJ": [
		"China Aerospace International Holdings Ltd",
		[
			0,
			"nc"
		],
		[
			1,
			"nc"
		],
		[
			4,
			"c"
		]
	],
	"0C00000OY2": [
		"China Shipbuilding Industry Group Power Co Ltd",
		[
			1,
			"n"
		]
	],
	"0C00000NXU": [
		"Indian Hotels Co Ltd",
		[
			0,
			"n"
		],
		[
			4,
			"n"
		]
	],
	"0C00001761": [
		"Tata Elxsi Ltd",
		[
			0,
			"n"
		],
		[
			4,
			"n"
		]
	],
	"0C00000CJ4": [
		"Tata Motors Ltd",
		[
			0,
			"n"
		],
		[
			4,
			"n"
		]
	],
	"0C0000175Y": [
		"Tata Chemicals Ltd",
		[
			4,
			"n"
		]
	],
	"0C00000MR5": [
		"Tata Consumer Products Ltd",
		[
			4,
			"n"
		]
	],
	"0C00001766": [
		"Tata Steel Ltd",
		[
			4,
			"n"
		]
	],
	"0C00001779": [
		"Titan Co Ltd",
		[
			4,
			"n"
		]
	],
	"0C0000177W": [
		"Trent Ltd",
		[
			4,
			"n"
		]
	],
	"0C000017AP": [
		"Voltas Ltd",
		[
			4,
			"n"
		]
	],
	"0C00000Q88": [
		"Weichai Power Co Ltd",
		[
			13
		]
	],
	"0C0000CHDV": [
		"4C Group AB",
		[
			11
		]
	],
	"0C0000AHJB": [
		"Ability Inc",
		[
			11
		]
	],
	"0C00003IRO": [
		"Abu Dhabi Ship Building PJSC",
		[
			11
		]
	],
	"0C0000APXI": [
		"Aerospace Industrial Development Corp",
		[
			11
		]
	],
	"0C00000D0U": [
		"Air Industries Group",
		[
			11
		]
	],
	"0C000008SJ": [
		"AMMO Inc",
		[
			11
		]
	],
	"0C00002D9P": [
		"Asahi-Seiki Manufacturing Co Ltd",
		[
			11
		]
	],
	"0C00003AXY": [
		"Bet Shemesh Engines Holdings (1997) Ltd",
		[
			11
		]
	],
	"0C0000CAUA": [
		"BigBear.ai Holdings Inc",
		[
			11
		]
	],
	"0C00003BYJ": [
		"Boustead Heavy Industries Corp Bhd",
		[
			11
		]
	],
	"0C0000072F": [
		"Butler National Corp",
		[
			11
		]
	],
	"0C00000AK3": [
		"Clarus Corp",
		[
			11
		]
	],
	"0C00000D6O": [
		"Coda Octopus Group Inc",
		[
			11
		]
	],
	"0C00000AS4": [
		"CPI Aerostructures Inc",
		[
			11
		]
	],
	"0C00003CKU": [
		"Destini Bhd",
		[
			11
		]
	],
	"0C000007ES": [
		"EMCORE Corp",
		[
			11
		]
	],
	"0C000007IL": [
		"Espey Manufacturing & Electronics Corp",
		[
			11
		]
	],
	"0C00008JGK": [
		"FMS Enterprises Migun Ltd",
		[
			11
		]
	],
	"0C00003BJR": [
		"Firstec Co Ltd",
		[
			11
		]
	],
	"0C00000AA5": [
		"Genasys Inc",
		[
			11
		]
	],
	"0C0000CSOE": [
		"Giga-Tronics Inc",
		[
			11
		]
	],
	"0C0000B4FD": [
		"GomSpace Group AB",
		[
			11
		]
	],
	"0C0000AYYB": [
		"H&K AG",
		[
			11
		]
	],
	"0C00000NL0": [
		"HFCL Ltd",
		[
			11
		]
	],
	"0C00003AHC": [
		"High Energy Batteries (India) Ltd",
		[
			11
		]
	],
	"0C00000MET": [
		"HighCom Ltd",
		[
			11
		]
	],
	"0C00003BKM": [
		"HJ Shipbuilding & Construction Co Ltd",
		[
			11
		]
	],
	"0C00002BA9": [
		"Howa Machinery Ltd",
		[
			11
		]
	],
	"0C00008O6B": [
		"Imco Industries Ltd",
		[
			11
		]
	],
	"0C00008JJQ": [
		"Jiangsu Yinhe Electronics Co Ltd",
		[
			11
		]
	],
	"0C0000DSUL": [
		"Loar Holdings Inc",
		[
			11
		]
	],
	"0C00000IHN": [
		"Magellan Aerospace Corp",
		[
			11
		]
	],
	"0C00008QPC": [
		"Mildef Crete Inc",
		[
			11
		]
	],
	"0C00002D9F": [
		"Miroku Corp",
		[
			11
		]
	],
	"0C00000OYW": [
		"North Navigation Control Technology Co Ltd",
		[
			11
		]
	],
	"0C00000BZ7": [
		"Olin Corp",
		[
			11
		]
	],
	"0C00000ZCU": [
		"Optex Systems Holdings Inc",
		[
			11
		]
	],
	"0C00000C11": [
		"Orbit International Corp",
		[
			11
		]
	],
	"0C00003B0S": [
		"Orbit Technologies Ltd",
		[
			11
		]
	],
	"0C00000C12": [
		"Orbital Corp Ltd",
		[
			11
		]
	],
	"0C0000C8UX": [
		"Palladyne AI Corp",
		[
			11
		]
	],
	"0C0000AVKW": [
		"PTC Industries Ltd",
		[
			11
		]
	],
	"0C00000M5U": [
		"Quickstep Holdings Ltd",
		[
			11
		]
	],
	"0C00009BTY": [
		"Romaero SA Bucuresti",
		[
			11
		]
	],
	"0C00008JIQ": [
		"R SL Electronics Ltd",
		[
			11
		]
	],
	"0C0000CT64": [
		"SDT Uzay Ve Savunma Teknolojeleri",
		[
			11
		]
	],
	"0C00000912": [
		"SIFCO Industries Inc",
		[
			11
		]
	],
	"0C00000938": [
		"Smith & Wesson Brands Inc",
		[
			11
		]
	],
	"0C00008HWV": [
		"Solid Inc",
		[
			11
		]
	],
	"0C00000Z6J": [
		"Solitron Devices Inc",
		[
			11
		]
	],
	"0C00003BMQ": [
		"STX Engine Co Ltd",
		[
			11
		]
	],
	"0C00000CI5": [
		"Sypris Solutions Inc",
		[
			11
		]
	],
	"0C00000CJ3": [
		"TAT Technologies Ltd",
		[
			11
		]
	],
	"0C00000CJ8": [
		"Taylor Devices Inc",
		[
			11
		]
	],
	"0C00000CK8": [
		"Tel Instrument Electronics Corp",
		[
			11
		]
	],
	"0C00000ZPG": [
		"Telos Corp",
		[
			11
		]
	],
	"0C00000D92": [
		"Dewey Electronics Corp",
		[
			11
		]
	],
	"0C00003730": [
		"Turbomecanica SA",
		[
			11
		]
	],
	"0C00000CT0": [
		"Ultralife Corp",
		[
			11
		]
	],
	"0C00008HTO": [
		"Victek Co Ltd",
		[
			11
		]
	],
	"0C000009IL": [
		"Video Display Corp",
		[
			11
		]
	],
	"0C00004AZ9": [
		"Zen Technologies Ltd",
		[
			11
		]
	],
	"0C0000098L": [
		"Adecco Group AG",
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C00000VWU": [
		"Alten",
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C000008FZ": [
		"ArcelorMittal SA",
		[
			11
		]
	],
	"0C00000VXA": [
		"Assystem SA",
		[
			11
		]
	],
	"0C00000MZ0": [
		"Capita PLC",
		[
			11
		]
	],
	"0C00000NEX": [
		"Costain Group PLC",
		[
			11
		]
	],
	"0C000035A6": [
		"The Israel Corp Ltd",
		[
			11
		]
	],
	"0C00000MYE": [
		"Kier Group PLC",
		[
			11
		]
	],
	"0C00000Y87": [
		"Komatsu Ltd",
		[
			11
		]
	],
	"0C00000U76": [
		"KSB SE & Co KGaA",
		[
			11
		]
	],
	"0C00000VLU": [
		"Lumibird",
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C00000MZP": [
		"Morgan Sindall Group PLC",
		[
			11
		]
	],
	"0C0000C2BX": [
		"MTAR Technologies Ltd",
		[
			11
		],
		[
			12,
			"n"
		]
	],
	"0C00006855": [
		"Schaeffler AG",
		[
			11
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/WffCompanySources.json
// module id = 1015
// module chunks = 0